import React, {useContext} from 'react';
import {Avatar, Box, Divider, IconButton, ListItemIcon, Menu, MenuItem, Tooltip, Typography,} from '@mui/material';
import {ReactComponent as ProfileIcon} from '../../../assets/icons/avatar.svg';
import {Logout} from '@mui/icons-material';
import {useAuth} from '../../../contexts/AuthenticationContext';
import {SidebarContext} from '../../../contexts/SidebarContext';
import {useTranslation} from 'react-i18next';

export default function Profile() {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const auth = useAuth();
    const { t } = useTranslation();

    const { sidebarToggle } = useContext(SidebarContext);

    const signOut = () => auth.signOut();

    const handleClick = (event: any) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    return (
        <Box
            sx={{
                display: 'flex',
                height: '90px',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-evenly',
                }}
            >
                <Tooltip title="Account">
                    <IconButton
                        onClick={handleClick}
                        size="small"
                        aria-controls={open ? 'account-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                    >
                        <Avatar sx={{ width: 32, height: 32 }}>
                            <ProfileIcon />
                        </Avatar>
                    </IconButton>
                </Tooltip>
                {sidebarToggle && (
                    <Typography sx={{ ml: 2 }}>
                        {auth.user && auth.user.name}
                    </Typography>
                )}
                <Menu
                    anchorEl={anchorEl}
                    id="account-menu"
                    open={open}
                    onClose={handleClose}
                    onClick={handleClose}
                    PaperProps={{
                        elevation: 0,
                        sx: {
                            overflow: 'visible',
                            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                            mt: 1.5,
                            '& .MuiAvatar-root': {
                                width: 32,
                                height: 32,
                                ml: -0.5,
                                mr: 1,
                            },
                        },
                    }}
                    transformOrigin={{ horizontal: 'left', vertical: 'bottom' }}
                    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                >
                    <MenuItem>
                        <Avatar />{auth.user?.name}
                    </MenuItem>
                    <Divider />
                    {/*<MenuItem>*/}
                    {/*    <ListItemIcon>*/}
                    {/*        <Settings fontSize="small" />*/}
                    {/*    </ListItemIcon>*/}
                    {/*    Settings*/}
                    {/*</MenuItem>*/}
                    <MenuItem onClick={() => signOut()}>
                        <ListItemIcon>
                            <Logout fontSize="small" />
                        </ListItemIcon>
                        {t('log_out')}
                    </MenuItem>
                </Menu>
            </Box>
        </Box>
    );
}
